export default {
    photo: 'Фотографии',
    delete: 'Удалить',
    uploadFaild: 'Не удалось загрузить изображение',
};
